import { ActionFunctionArgs } from "react-router";
import { config } from '../../config';
import { prepareHeaders } from '../../configuration/tokenHandling/prepareHeaders';

import type { LoaderFunctionArgs } from "react-router";
import { ExtractData } from "./types/types";


async function extractLoader({ request }: LoaderFunctionArgs) {
  const url = new URL(request.url);
  const tripId = url.searchParams.get("trip_id");
  const behaviorType = url.searchParams.get("behavior_type");

  if (!tripId || !behaviorType) {
    return null;
  }

  const headers = await prepareHeaders(new Headers());
  const body = JSON.stringify({ trip_id: tripId, behavior_type: behaviorType});
  const apiUrl = config.backend.SCORES_SERVICE + `/v2/scores/extract`

  const response = await fetch(apiUrl, {method: "POST", body, headers});
  const data: ExtractData = await response.json();

  return {response: data};
}

export { extractLoader };